import config from 'constants/config'
import getPaymentMethods from './getPaymentMethods'
import {
  LATITUDE_PAYMENT_TYPE,
  LATITUDE_GEM_PAYMENT_TYPE,
  LATITUDE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

export function isLatitudeFinanceEnabled(currency: string) {
  return config.LATITUDE_ENABLED &&
  getPaymentMethods(currency).includes(LATITUDE_PAYMENT_TYPE)
}

export function isLatitudeGemEnabled(currency: string) {
  return config.LATITUDE_GEM_ENABLED &&
  getPaymentMethods(currency).includes(LATITUDE_GEM_PAYMENT_TYPE)
}

export function isLatitudePayEnabled(currency: string) {
  return config.LATITUDE_PAY_ENABLED &&
    getPaymentMethods(currency).includes(LATITUDE_PAY_PAYMENT_TYPE)
}

export function isLatitudeEnabled(currency: string) {
  return isLatitudeFinanceEnabled(currency) ||
         isLatitudeGemEnabled(currency) ||
         isLatitudePayEnabled(currency)
}
